export function formatPrice(price) {
	const formatter = new Intl.NumberFormat('nl-NL', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 0
	});

	return formatter.format(price);
}

export function jsUcfirst(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export function arrayContains(needle, arrhaystack) {
	if(arrhaystack.length === 0) {
		return false;
	}
	return (arrhaystack.indexOf(needle) > -1);
}

export function toLetters(num) {
	let mod = num % 26,
		pow = num / 26 | 0,
		out = mod ? String.fromCharCode(64 + mod) : (--pow, 'Z');
	return pow ? toLetters(pow) + out : out;
}

export function isEmpty(obj) {
	if(obj === '') {
		return true;
	}

	for(let key in obj) {
		if(obj.hasOwnProperty(key))
			return false;
	}
	return true;
}

export function formatNumber(number) {
	return new Intl.NumberFormat('nl-NL', {style: 'decimal'}).format(number);
}

export function getMenuFontSize(string) {

	if ( string.length > 45 ) {

		return '4px';

	} else if ( string.length > 42 ) {

		return '5px';

	} else if ( string.length > 37 ) {

		return '6px';

	} else if ( string.length > 32 ) {

		return '7px';

	} else if ( string.length > 28 ) {

		return '8px';

	} else if ( string.length > 25 ) {

		return '9px';

	} else if ( string.length > 20 ) {

		return '10px';

	} else {

		return '12px';

	}

}

export function isset(object, value) {
    return object.hasOwnProperty(value)
}

export function createFromMysql(mysql_string) {
    let t, result = null;

    if (typeof mysql_string === 'string') {
        t = mysql_string.split(/[- :]/);
        //when t[3], t[4] and t[5] are missing they defaults to zero
        result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
    }

    return result;
}

export const getUrlParams = (search = '') => {
    let hashes = search.slice(search.indexOf('?') + 1).split('&');
    return hashes.reduce((params, hash) => {
        let [key, val] = hash.split('=');
        return val !== undefined
            ? Object.assign(params, {[key]: decodeURIComponent(val)})
            : params;
    }, {});
};

// Courtesy of CodeGuy https://gist.github.com/codeguy/6684588
export const slugify = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeiiiioooouuuunc------";

    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}
